import React, { FC, MouseEvent, useState } from 'react';
import Link from 'next/link';
import Icon from '@common/assets';
import Image from '@components/common/image';

import { useToast } from '@components/common/toast';
import { useLoginModal } from '@components/loginModal/LoginModalContext';
import { useAddBookmark, useDeleteBookmark } from '@repository/position/usePosition';
import { PositionJobCardDto } from '@domain/rs/position/jd/PositionJobListCardRs';
import Colors from '@domain/constant/colors';
import { dummyImgSrc } from '@domain/constant/img/positionDummyImgSrc';
import { V2Route } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './personalPositionListItem.module.scss';
const cx = classnames.bind(styles);

interface JobOpeningImageListItemProps {
  data: PositionJobCardDto;
  dragging?: () => void;
}

const PersonalPositionListItem: FC<JobOpeningImageListItemProps> = ({ data, dragging }) => {
  const Toast = useToast();
  const { mutate: deleteBookmark } = useDeleteBookmark();
  const { mutate: addBookmark } = useAddBookmark();
  const { isLogin, openLoginModal } = useLoginModal();
  const { companyName, positionName, bookmarkYn, logoImageUrl, teamImageUrl } = data;
  const [bookmark, setBookmark] = useState(bookmarkYn);

  const handleBookMark = async (e: MouseEvent) => {
    e.preventDefault();

    if (!isLogin) {
      openLoginModal();
      return;
    }

    if (bookmark)
      deleteBookmark(data.positionSn, {
        onSuccess: () => {
          setBookmark(false);
          Toast({ iconType: 'bookmark', content: '[지원현황] > 북마크에서 삭제되었어요.', size: 'content' });
        },
      });
    else
      addBookmark(data.positionSn, {
        onSuccess: () => {
          setBookmark(true);
          Toast({ iconType: 'bookmark', content: '[지원현황] > 북마크에 저장되었어요.', size: 'content' });
        },
      });
  };

  return (
    <Link
      className={cx('listItem')}
      href={V2Route.getPositionJDPage(data.positionSn)}
      onClick={(e) => {
        if (dragging?.()) {
          e.preventDefault();
        }
      }}
    >
      {/* [D] 썸네일 이미지 개발 필요 */}
      <div className={cx('imgWrap')}>
        <div className={cx('imgArea')}>
          {teamImageUrl ? (
            <Image
              src={teamImageUrl}
              alt={`${companyName} 회사`}
              className={cx('thumbnailImg')}
              width={280}
              height={178}
              pointer
            />
          ) : (
            <div className={cx('dummyImg')}>
              <Image src={dummyImgSrc} alt="dummyImg" fill pointer />
            </div>
          )}
        </div>

        {/* [D] 북마크 영역 개발 필요 */}
        <a className={cx('btnBookmark')} role="button" onClick={handleBookMark}>
          {/* [D] 북마크 된 경우 'IconBookmarkLightFilled' 아이콘 적용 */}
          {bookmark ? (
            <Icon name="bookmarkLightFilled" width={32} height={32} fill={Colors.C_WHITE} />
          ) : (
            <Icon name="bookmarkLight" width={32} height={32} fill={Colors.C_WHITE} />
          )}
          <span className={cx('hidden')}>북마크</span>
        </a>
      </div>

      {/* [D] 포지션 정보 */}
      <div className={cx('companyInfoArea')}>
        {/* 포지션명 */}
        <div className={cx('jobPostTitleWrap')}>{positionName}</div>

        {/* 기업명 */}
        <div className={cx('companyNameWrap')}>
          <div className={cx('logo', { default: !logoImageUrl })}>
            {logoImageUrl ? (
              <Image src={logoImageUrl} alt={`${companyName} 로고`} width={32} height={32} />
            ) : (
              <Icon name="logo" width={32} height={7} fill={Colors.C_COOL_GRAY_50} />
            )}
          </div>
          <div className={cx('companyName')}>{companyName}</div>
        </div>
      </div>
    </Link>
  );
};

export default PersonalPositionListItem;
